function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/UserApi";
import * as UserModalComponent from "./UserModalComponent";
import * as UserResetModalComponent from "./UserResetModalComponent";
import * as UserThumbnailModalComponent from "./UserThumbnailModalComponent";
import * as UserAvatarModalComponent from "./UserAvatarModalComponent";
import { NullNumberToBlank, ToDateString } from "../commons/Utility";
import { ApiResultCodes } from "../enum/ApiResultCodes";
import * as UserGroupNarrowdownModalComponent from "./UserGroupNarrowdownModalComponent";
import IntlMessage from '../commons/Intl';
import { Action, Users, Placeholder, Authorities } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Selected: null,
      AcessToken: "",
      CurrentOrganizationId: 0,
      CurrentUserId: 0,
      CurrentUserAuthorityId: 0,
      OrganizationId: 0,
      Domain: "",
      UserList: [],
      UserModalMode: UserModalComponent.Mode.None,
      UserResetModalMode: UserResetModalComponent.Mode.None,
      UserThumbnailModalMode: UserThumbnailModalComponent.Mode.None,
      UserAvatarModalMode: UserAvatarModalComponent.Mode.None,
      SearchText: "",
      CurrentPage: 1,
      DataCount: 0,
      DataAllCount: 0,
      UserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None,
      UserGroupNarrowdownGroupNamesText: "",
      UserGroupNarrowdownSelectedGroupIdList: [],
      UserGroupNarrowdownUserIdList: [],
      UserGroupNarrowdownModalLeft: 0,
      UserGroupNarrowdownModalTop: 0
    };
    _this.waitLoaded = 0;

    _this.GetList(_this.state.CurrentPage);

    _this.changeWindowFunction = _this.changeWindow.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * ウィンドウ変更時
   */


  _createClass(MainComponent, [{
    key: "changeWindow",
    value: function changeWindow() {
      var btn = $('#OpenUserGroupNarrowdown-button');
      var btn_off = btn.offset();
      var windowScrollTop = $(window).scrollTop();
      var windowScrollLeft = $(window).scrollLeft();

      if (btn && btn_off && windowScrollTop != undefined && windowScrollLeft != undefined) {
        var outerHeight = btn.outerHeight(false);

        if (outerHeight) {
          this.setState({
            UserGroupNarrowdownModalTop: btn_off.top + outerHeight - windowScrollTop,
            UserGroupNarrowdownModalLeft: btn_off.left - windowScrollLeft
          });
        }
      }
    }
    /**
     * 対象の検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSearchText",
    value: function updateSearchText(e) {
      this.setState({
        SearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * リスト表示
     */

  }, {
    key: "GetList",
    value: function GetList(pageNum) {
      var _this2 = this;

      Api.Query(this.state.SearchText, this.state.UserGroupNarrowdownSelectedGroupIdList.length > 0, this.state.UserGroupNarrowdownUserIdList, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this2.setState({
          AcessToken: data.AccessToken,
          CurrentOrganizationId: data.CurrentOrganizationId,
          CurrentUserId: data.CurrentUserId,
          CurrentUserAuthorityId: data.CurrentUserAuthorityId,
          OrganizationId: data.OrganizationId,
          Domain: data.Domain,
          Selected: null,
          UserList: data.UserList,
          DataCount: data.Count,
          DataAllCount: data.AllCount
        });
      });
    }
    /**
     * リスト表示
     */

  }, {
    key: "GetListAnd",
    value: function GetListAnd(pageNum, callback) {
      var _this3 = this;

      Api.Query(this.state.SearchText, this.state.UserGroupNarrowdownSelectedGroupIdList.length > 0, this.state.UserGroupNarrowdownUserIdList, (pageNum - 1) * this.props.pageSize + 1, this.props.pageSize, function (data) {
        _this3.setState({
          AcessToken: data.AccessToken,
          CurrentOrganizationId: data.CurrentOrganizationId,
          CurrentUserId: data.CurrentUserId,
          CurrentUserAuthorityId: data.CurrentUserAuthorityId,
          OrganizationId: data.OrganizationId,
          Domain: data.Domain,
          Selected: null,
          UserList: data.UserList,
          DataCount: data.Count,
          DataAllCount: data.AllCount
        });

        callback();
      });
    }
    /**
     * 前ページ表示
     */

  }, {
    key: "previousPage",
    value: function previousPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;

      if (this.state.CurrentPage <= 1) {
        page = 1;
      } else {
        page = this.state.CurrentPage - 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * 次ページ表示
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 0;
      var maxPage = Math.ceil(this.state.DataCount / this.props.pageSize);

      if (maxPage == 0) {
        page = 1;
      } else if (this.state.CurrentPage >= maxPage) {
        page = maxPage;
      } else {
        page = this.state.CurrentPage + 1;
      }

      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * ユーザーモーダルを追加で起動します。
     */

  }, {
    key: "openAddUserModal",
    value: function openAddUserModal() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserModalMode: UserModalComponent.Mode.Add
      });
    }
    /**
     * ユーザーモーダルを編集で起動します。
     */

  }, {
    key: "openModifyUserModal",
    value: function openModifyUserModal(m) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserModalMode: UserModalComponent.Mode.Modify,
        Selected: {
          UserId: m.UserId,
          UserName: m.UserName,
          UserMailAddress: m.UserMailAddress,
          ThumbnailFileName: m.ThumbnailFileName,
          AvatarFileName: m.AvatarFileName,
          ConversionStatus: m.ConversionStatus,
          OrganizationId: m.OrganizationId,
          AuthorityId: m.AuthorityId,
          AuthorityName: m.AuthorityName,
          CanSupport: m.CanSupport,
          ContractManagerFlag: m.ContractManagerFlag,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * 組織を検索します。
     *
     * @param searchText 検索文字列
     */

  }, {
    key: "searchUser",
    value: function searchUser() {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      var page = 1;
      this.setState({
        CurrentPage: page
      });
      this.GetList(page);
    }
    /**
     * ユーザーを登録します。
     *
     * @param userName ユーザー名
     * @param userMailAddress ユーザーメールアドレス
     * @param authorityId 権限ＩＤ
     * @param canSupport サポート可否
     * @param contractManagerFlag 契約管理者フラグ
     * @param closeEvent 終了処理
     */

  }, {
    key: "entryUserModal",
    value: function entryUserModal(userName, userMailAddress, authorityId, canSupport, contractManagerFlag, closeEvent) {
      var _this4 = this;

      Api.AddUser(userName, userMailAddress, authorityId, canSupport, contractManagerFlag, function (data) {
        _this4.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          closeEvent();

          _this4.GetList(_this4.state.CurrentPage);
        }
      });
    }
    /**
     * ユーザーを更新します。
     *
     * @param userId ユーザーID
     * @param userName ユーザー名
     * @param userMailAddress ユーザーメールアドレス
     * @param organizationId 組織ＩＤ
     * @param currentAuthorityId 現在の権限ＩＤ
     * @param authorityId 権限ID
     * @param canSupport サポート可否
     * @param contractManagerFlag 契約管理者フラグ
     * @param updateDateTime 更新日時
     * @param closeEvent 終了処理
     */

  }, {
    key: "modifyUserModal",
    value: function modifyUserModal(userId, userName, userMailAddress, organizationId, currentAuthorityId, authorityId, canSupport, contractManagerFlag, updateDateTime, closeEvent) {
      var _this5 = this;

      Api.ModifyUser(userId, userName, userMailAddress, organizationId, currentAuthorityId, authorityId, canSupport, contractManagerFlag, updateDateTime, function (data) {
        _this5.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          closeEvent();

          _this5.GetList(_this5.state.CurrentPage);
        }
      });
    }
    /**
     * ユーザーを削除します。
     *
     * @param sessionId セッションＩＤ
     * @param OrganizationId ページＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteUserModal",
    value: function deleteUserModal(UserId, UpdateDateTime) {
      var _this6 = this;

      Api.DeleteUser(UserId, UpdateDateTime, function (data) {
        _this6.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this6.GetList(_this6.state.CurrentPage);
        }
      });
    }
    /**
     * ユーザーモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserModal",
    value: function hiddenUserModal() {
      this.setState({
        UserModalMode: UserModalComponent.Mode.None
      });
    }
    /**
     * ユーザーパスワードモーダルを追加で起動します。
     */

  }, {
    key: "openUserResetModal",
    value: function openUserResetModal(m) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserResetModalMode: UserResetModalComponent.Mode.Send,
        Selected: {
          UserId: m.UserId,
          UserName: m.UserName,
          UserMailAddress: m.UserMailAddress,
          ThumbnailFileName: m.ThumbnailFileName,
          AvatarFileName: m.AvatarFileName,
          ConversionStatus: m.ConversionStatus,
          OrganizationId: m.OrganizationId,
          AuthorityId: m.AuthorityId,
          AuthorityName: m.AuthorityName,
          CanSupport: m.CanSupport,
          ContractManagerFlag: m.ContractManagerFlag,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * ユーザーパスワードのリセットを要求します。
     *
     * @param userId ユーザーID
     */

  }, {
    key: "sendUserResetModal",
    value: function sendUserResetModal(userId) {
      var _this7 = this;

      Api.RequestResetPassword(userId, function (data) {
        _this7.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this7.GetList(_this7.state.CurrentPage);
        }
      });
    }
    /**
     * ユーザーパスワードモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserResetModal",
    value: function hiddenUserResetModal() {
      this.setState({
        UserResetModalMode: UserResetModalComponent.Mode.None
      });
    }
    /**
     * ユーザーサムネイルモーダルを起動します。
     */

  }, {
    key: "openUserThumbnailModal",
    value: function openUserThumbnailModal(m) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserThumbnailModalMode: UserThumbnailModalComponent.Mode.Modify,
        Selected: {
          UserId: m.UserId,
          UserName: m.UserName,
          UserMailAddress: m.UserMailAddress,
          ThumbnailFileName: m.ThumbnailFileName,
          AvatarFileName: m.AvatarFileName,
          ConversionStatus: m.ConversionStatus,
          OrganizationId: m.OrganizationId,
          AuthorityId: m.AuthorityId,
          AuthorityName: m.AuthorityName,
          CanSupport: m.CanSupport,
          ContractManagerFlag: m.ContractManagerFlag,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * ユーザーサムネイルを更新します。
     *
     * @param userId ユーザーＩＤ
     * @param thumbnail サムネイル
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserThumbnailModal",
    value: function modifyUserThumbnailModal(userId, thumbnail, updateDateTime) {
      var _this8 = this;

      Api.UploadThumbnail(userId, thumbnail, updateDateTime, function (data) {
        _this8.setState({
          Selected: null
        });

        var model = data;

        if (model.ResultCode == ApiResultCodes.LengthError) {
          alert(model.ResultMessage);
        }

        _this8.GetList(_this8.state.CurrentPage);
      });
    }
    /**
     * ユーザーサムネイルを更新します。
     *
     * @param userId ユーザーＩＤ
     * @param thumbnail サムネイル
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserThumbnailAndReopenModal",
    value: function modifyUserThumbnailAndReopenModal(userId, thumbnail, updateDateTime) {
      var _this9 = this;

      Api.UploadThumbnail(userId, thumbnail, updateDateTime, function (data) {
        _this9.setState({
          Selected: null
        });

        var model = data;

        if (model.ResultCode == ApiResultCodes.LengthError) {
          alert(model.ResultMessage);
        }

        _this9.GetListAnd(_this9.state.CurrentPage, function () {
          var userDetailModel = _this9.state.UserList.find(function (x) {
            return x.UserId == userId;
          });

          _this9.openUserThumbnailModal(userDetailModel);
        });
      });
    }
    /**
     * ユーザーサムネイルを削除します。
     *
     * @param sessionId セッションＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteUserThumbnailModal",
    value: function deleteUserThumbnailModal(userId, updateDateTime) {
      var _this10 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.DeleteThumbnail(userId, updateDateTime, function (data) {
        _this10.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this10.GetList(_this10.state.CurrentPage);
        }

        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
      });
    }
    /**
     * ユーザーサムネイルモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserThumbnailModal",
    value: function hiddenUserThumbnailModal() {
      this.setState({
        UserThumbnailModalMode: UserThumbnailModalComponent.Mode.None
      });
    }
    /**
     * ユーザーアバターモーダルを起動します。
     */

  }, {
    key: "openUserAvatarModal",
    value: function openUserAvatarModal(m) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      this.setState({
        UserAvatarModalMode: UserAvatarModalComponent.Mode.Modify,
        Selected: {
          UserId: m.UserId,
          UserName: m.UserName,
          UserMailAddress: m.UserMailAddress,
          ThumbnailFileName: m.ThumbnailFileName,
          AvatarFileName: m.AvatarFileName,
          ConversionStatus: m.ConversionStatus,
          OrganizationId: m.OrganizationId,
          AuthorityId: m.AuthorityId,
          AuthorityName: m.AuthorityName,
          CanSupport: m.CanSupport,
          ContractManagerFlag: m.ContractManagerFlag,
          UpdateDateTime: m.UpdateDateTime
        }
      });
    }
    /**
     * ユーザーアバターを作成します。
     *
     * @param userId ユーザーＩＤ
     * @param downloadUrl ダウンロードURL
     * @param updateDateTime 更新日時
     */

  }, {
    key: "createUserAvatarModal",
    value: function createUserAvatarModal(userId, downloadUrl, updateDateTime) {
      var _this11 = this;

      Api.CreateAvatar(userId, downloadUrl, updateDateTime, function (data) {
        _this11.setState({
          Selected: null
        });

        var model = data;

        if (model.ResultCode == ApiResultCodes.LengthError) {
          alert(model.ResultMessage);
        }

        _this11.GetListAnd(_this11.state.CurrentPage, function () {
          var userDetailModel = _this11.state.UserList.find(function (x) {
            return x.UserId == userId;
          });

          _this11.openUserAvatarModal(userDetailModel);
        });
      });
    }
    /**
     * ユーザーアバターを更新します。
     *
     * @param userId ユーザーＩＤ
     * @param avator アバター
     * @param updateDateTime 更新日時
     */

  }, {
    key: "modifyUserAvatarModal",
    value: function modifyUserAvatarModal(userId, avator, updateDateTime) {
      var _this12 = this;

      Api.UploadAvatar(userId, avator, updateDateTime, function (data) {
        _this12.setState({
          Selected: null
        });

        var model = data;

        if (model.ResultCode == ApiResultCodes.LengthError) {
          alert(model.ResultMessage);
        }

        _this12.GetListAnd(_this12.state.CurrentPage, function () {
          var userDetailModel = _this12.state.UserList.find(function (x) {
            return x.UserId == userId;
          });

          _this12.openUserAvatarModal(userDetailModel);
        });
      });
    }
    /**
     * ユーザーアバターを調整します。
     *
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "adjustUserAvatarModal",
    value: function adjustUserAvatarModal(userId) {
      if ($("#content-header")) {
        $("#content-header").remove();
      }

      if (this.waitLoaded > 0) return;
      if (!this.props.common.gameLoad) return;
      $("#normal").hide();
      $("#avatarCustomizer").show();
      this.props.common.gameInstance = this.props.common.gameLoad();

      if (this.props.common.gameLoaded) {
        this.openAdjustUserAvatarModal(userId);
      } else {
        this.waitLoaded = window.setInterval(this.waitingLoaded.bind(this, userId), 500);
      }
    }
    /**
     * ユーザーアバターを調整画面を表示します
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "waitingLoaded",
    value: function waitingLoaded(userId) {
      if (this.props.common.gameLoaded) {
        window.clearInterval(this.waitLoaded);
        this.openAdjustUserAvatarModal(userId);
        this.waitLoaded = 0;
      }
    }
    /**
     * ユーザーアバターを調整画面を表示します
     * @param userId ユーザーＩＤ
     */

  }, {
    key: "openAdjustUserAvatarModal",
    value: function openAdjustUserAvatarModal(userId) {
      var _this13 = this;

      this.GetListAnd(this.state.CurrentPage, function () {
        var _userDetailModel$Avat, _userDetailModel$Avat2, _userDetailModel$Avat3;

        var userDetailModel = _this13.state.UserList.find(function (x) {
          return x.UserId == userId;
        });

        var data = {
          "Type": "StartViewing",
          "Data": {
            "CommonInfo": {
              "AccessToken": _this13.state.AcessToken
            },
            "UserInfo": {
              "Id": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.UserId,
              "Name": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.UserName,
              "AvatarFileName": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.AvatarFileName,
              "OrganizationId": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.OrganizationId,
              "AuthorityId": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.AuthorityId,
              "ThumbnailFileName": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.ThumbnailFileName,
              "UpdateDateTime": userDetailModel ? ToDateString(Number(userDetailModel.UpdateDateTime)) : ""
            },
            "AvatarInfo": {
              "UserId": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.UserId,
              "AvatarFileName": userDetailModel === null || userDetailModel === void 0 ? void 0 : userDetailModel.AvatarFileName,
              "Scale": userDetailModel === null || userDetailModel === void 0 ? void 0 : (_userDetailModel$Avat = userDetailModel.AvatarInfo) === null || _userDetailModel$Avat === void 0 ? void 0 : _userDetailModel$Avat.Scale,
              "OffsetY": userDetailModel === null || userDetailModel === void 0 ? void 0 : (_userDetailModel$Avat2 = userDetailModel.AvatarInfo) === null || _userDetailModel$Avat2 === void 0 ? void 0 : _userDetailModel$Avat2.OffsetY,
              "MaterialPreset": userDetailModel === null || userDetailModel === void 0 ? void 0 : (_userDetailModel$Avat3 = userDetailModel.AvatarInfo) === null || _userDetailModel$Avat3 === void 0 ? void 0 : _userDetailModel$Avat3.MaterialPreset,
              "UpdateDateTimeString": userDetailModel && userDetailModel.AvatarInfo ? ToDateString(Number(userDetailModel.AvatarInfo.UpdateDateTime)) : "",
              "UpdateDateTime": userDetailModel && userDetailModel.AvatarInfo ? ToDateString(Number(userDetailModel.AvatarInfo.UpdateDateTime)) : ""
            }
          }
        };
        var dataJson = JSON.stringify(data);

        _this13.props.common.gameInstance.SendMessage("Control", "InvokePageEvent", dataJson);
      });
    }
    /**
     * ユーザーアバターを削除します。
     *
     * @param userId ユーザーＩＤ
     * @param updateDateTime 更新日時
     */

  }, {
    key: "deleteUserAvatarModal",
    value: function deleteUserAvatarModal(userId, updateDateTime) {
      var _this14 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.DeleteAvatar(userId, updateDateTime, function (data) {
        _this14.setState({
          Selected: null
        });

        if (data.ResultCode == ApiResultCodes.Success) {
          _this14.GetList(_this14.state.CurrentPage);
        }

        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
      });
    }
    /**
     * ユーザーアバターモーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenUserAvatarModal",
    value: function hiddenUserAvatarModal() {
      this.setState({
        UserAvatarModalMode: UserAvatarModalComponent.Mode.None
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.common.bind();
      window.addEventListener('resize', this.changeWindowFunction);
      window.addEventListener('scroll', this.changeWindowFunction);
    }
    /**
     * コンポーネントが破棄(アンマウント)される前に実行されます。
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.changeWindowFunction);
      window.removeEventListener('scroll', this.changeWindowFunction);
    }
    /**
     * 権限名を戻します。
     *
     * @param authorityId 権限ID
     */

  }, {
    key: "getAuthorityName",
    value: function getAuthorityName(authorityId) {
      switch (authorityId) {
        case 1:
          return intl.format(Authorities.SystemAdmin);

        case 2:
          return intl.format(Authorities.OrgAdmin);

        case 3:
          return intl.format(Authorities.User);

        case 4:
          return intl.format(Authorities.Supporter);

        case 5:
          return intl.format(Authorities.Guest);

        default:
          return "";
      }
    }
    /**
     * ユーザーグループ絞り込みを開きます。
     */

  }, {
    key: "onOpenUserGroupNarrowdown",
    value: function onOpenUserGroupNarrowdown(e) {
      if (this.state.UserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None) {
        return;
      }

      e.stopPropagation();
      this.changeWindow();
      this.setState({
        UserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.Open
      });
    }
    /**
     * 対象のグループの変更
     */

  }, {
    key: "onChangeUserGroupNarrowdown",
    value: function onChangeUserGroupNarrowdown(groupNamesText, selectedGroupIdList, userIds, _userKeys) {
      var _this15 = this;

      this.setState({
        CurrentPage: 1,
        UserGroupNarrowdownGroupNamesText: groupNamesText,
        UserGroupNarrowdownSelectedGroupIdList: selectedGroupIdList,
        UserGroupNarrowdownUserIdList: userIds
      }, function () {
        _this15.GetList(_this15.state.CurrentPage);
      });
    }
    /**
     * 外枠マウスダウン
     */

  }, {
    key: "onOutSide",
    value: function onOutSide(e) {
      if (this.state.UserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None) {
        e.preventDefault();
        this.setState({
          UserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None
        });
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this16 = this;

      return /*#__PURE__*/React.createElement("div", {
        onClick: this.onOutSide.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("div", {
        id: "avatarCustomizer",
        style: {
          display: "none"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: "UpdateAvatarInfo"
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Data",
        id: "Data",
        value: ""
      }), /*#__PURE__*/React.createElement("div", {
        id: "gameContainer"
      }), /*#__PURE__*/React.createElement("div", {
        id: "loader"
      }, /*#__PURE__*/React.createElement("img", {
        className: "bouncing-cube",
        src: "assets/img/whiteroomlogo_cube.svg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "spinner"
      }), /*#__PURE__*/React.createElement("div", {
        className: "progress"
      }, /*#__PURE__*/React.createElement("div", {
        className: "full"
      })))), /*#__PURE__*/React.createElement("div", {
        id: "normal"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, /*#__PURE__*/React.createElement("img", {
        width: "60",
        height: "60",
        src: "/assets/img/user_icon.svg"
      }), /*#__PURE__*/React.createElement("h2", null, intl.format(Users.Title)))), /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-10 offset-1 col-lg-6 offset-lg-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control-search",
        name: "search",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this16.updateSearchText(e);
        },
        value: this.state.SearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-6 search-btn row"
      }, /*#__PURE__*/React.createElement("a", {
        className: "col-2 button",
        href: "#",
        onClick: this.searchUser.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Search"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/search_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-8 selectbox"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "OpenUserGroupNarrowdown-button",
        onClick: this.onOpenUserGroupNarrowdown.bind(this),
        tabIndex: -1
      }, this.state.UserGroupNarrowdownGroupNamesText)), this.state.UserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserGroupNarrowdownModalComponent["default"], {
        mode: this.state.UserGroupNarrowdownModalMode,
        selectedGroupIdList: this.state.UserGroupNarrowdownSelectedGroupIdList,
        onChange: this.onChangeUserGroupNarrowdown.bind(this),
        top: this.state.UserGroupNarrowdownModalTop,
        left: this.state.UserGroupNarrowdownModalLeft
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddUserModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add user"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-middle"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.UserList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.UserId
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-1"
        }, (_this16.state.CurrentPage - 1) * _this16.props.pageSize + _i + 1), /*#__PURE__*/React.createElement("div", {
          className: "col-3 cursorpointer",
          style: {
            wordWrap: "break-word"
          },
          onClick: _this16.openModifyUserModal.bind(_this16, x)
        }, x.UserName), /*#__PURE__*/React.createElement("div", {
          className: "col-2 cursorpointer",
          onClick: _this16.openModifyUserModal.bind(_this16, x)
        }, _this16.getAuthorityName(x.AuthorityId)), /*#__PURE__*/React.createElement("div", {
          className: "col-2 overflow-hidden"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-primary thumbnail-btn",
          onClick: _this16.openUserThumbnailModal.bind(_this16, x),
          tabIndex: -1
        }, intl.format(Action.ChangeThumbnail))), /*#__PURE__*/React.createElement("div", {
          className: "col-2 overflow-hidden"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "btn btn-primary avatar-btn",
          onClick: _this16.openUserAvatarModal.bind(_this16, x),
          tabIndex: -1
        }, intl.format(Action.ChangeAvatar))), /*#__PURE__*/React.createElement("div", {
          className: "col-2 overflow-hidden"
        }, /*#__PURE__*/React.createElement("button", {
          key: "onPwchange",
          type: "button",
          className: "btn btn-primary password-btn",
          onClick: _this16.openUserResetModal.bind(_this16, x),
          tabIndex: -1
        }, intl.format(Action.ResetPassword)))));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-1 offset-10 text-right"
      }, /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.openAddUserModal.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Add user"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "36",
        height: "36",
        src: "/assets/img/add_icon.svg"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-1 text-right paging-btn"
      }, this.state.CurrentPage <= 1 && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage > 1 && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.previousPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Previous"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_left.svg"
      })), this.state.CurrentPage >= Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button disabled",
        href: "#",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      })), this.state.CurrentPage < Math.ceil(this.state.DataCount / this.props.pageSize) && /*#__PURE__*/React.createElement("a", {
        className: "button",
        href: "#",
        onClick: this.nextPage.bind(this),
        "data-toggle": "tooltip",
        "data-animation": "false",
        "data-placement": "bottom",
        "data-delay": "0",
        title: "Next"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "24",
        height: "24",
        src: "/assets/img/arrow_rigth.svg"
      }))))))), this.state.UserModalMode != UserModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserModalComponent["default"], {
        mode: this.state.UserModalMode,
        curOrganizationId: NullNumberToBlank(this.state.CurrentOrganizationId),
        curUserId: NullNumberToBlank(this.state.CurrentUserId),
        curUserAuthorityId: this.state.CurrentUserAuthorityId,
        domain: this.state.Domain,
        userId: NullNumberToBlank(this.state.Selected ? this.state.Selected.UserId : null),
        userName: this.state.Selected ? this.state.Selected.UserName : "",
        userMailAddress: this.state.Selected ? this.state.Selected.UserMailAddress : "",
        organizationId: NullNumberToBlank(this.state.Selected ? this.state.Selected.OrganizationId : this.state.OrganizationId),
        authorityId: NullNumberToBlank(this.state.Selected ? this.state.Selected.AuthorityId : null),
        thumbnailFileName: this.state.Selected ? this.state.Selected.ThumbnailFileName : "",
        canSupport: NullNumberToBlank(this.state.Selected ? this.state.Selected.CanSupport : null),
        contractManagerFlag: this.state.Selected ? this.state.Selected.ContractManagerFlag : false,
        updateDateTime: this.state.Selected ? this.state.Selected.UpdateDateTime : "",
        onEntry: this.entryUserModal.bind(this),
        onModify: this.modifyUserModal.bind(this),
        onDelete: this.deleteUserModal.bind(this),
        onHidden: this.hiddenUserModal.bind(this)
      }), this.state.UserResetModalMode != UserResetModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserResetModalComponent["default"], {
        mode: this.state.UserResetModalMode,
        userId: NullNumberToBlank(this.state.Selected ? this.state.Selected.UserId : null),
        userName: this.state.Selected ? this.state.Selected.UserName : "",
        thumbnailFileName: this.state.Selected ? this.state.Selected.ThumbnailFileName : "",
        onSend: this.sendUserResetModal.bind(this),
        onHidden: this.hiddenUserResetModal.bind(this)
      }), this.state.UserThumbnailModalMode != UserThumbnailModalComponent.Mode.None && this.state.Selected && /*#__PURE__*/React.createElement(UserThumbnailModalComponent["default"], {
        mode: this.state.UserThumbnailModalMode,
        isDefault: this.state.Selected.ThumbnailFileName == null,
        userId: NullNumberToBlank(this.state.Selected.UserId),
        thumbnailFileName: this.state.Selected.ThumbnailFileName,
        updateDateTime: this.state.Selected.UpdateDateTime,
        onEntry: this.modifyUserThumbnailModal.bind(this),
        onUpload: this.modifyUserThumbnailAndReopenModal.bind(this),
        onDefault: this.deleteUserThumbnailModal.bind(this),
        onHidden: this.hiddenUserThumbnailModal.bind(this)
      }), this.state.UserAvatarModalMode != UserAvatarModalComponent.Mode.None && this.state.Selected && /*#__PURE__*/React.createElement(UserAvatarModalComponent["default"], {
        common: this.props.common,
        mode: this.state.UserAvatarModalMode,
        queryRefreshInterval: this.props.queryRefreshInterval,
        isDefault: this.state.Selected.AvatarFileName == null,
        canDelete: true,
        userId: NullNumberToBlank(this.state.Selected.UserId),
        avatarFileName: this.state.Selected.AvatarFileName,
        thumbnailFileName: this.state.Selected.ThumbnailFileName,
        conversionStatus: this.state.Selected.ConversionStatus,
        updateDateTime: this.state.Selected.UpdateDateTime,
        authorityId: this.state.CurrentUserAuthorityId,
        onCreate: this.createUserAvatarModal.bind(this),
        onModify: this.modifyUserAvatarModal.bind(this),
        onAdjust: this.adjustUserAvatarModal.bind(this),
        onDefault: this.deleteUserAvatarModal.bind(this),
        onHidden: this.hiddenUserAvatarModal.bind(this)
      })));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param queryRefreshInterval 検索リフレッシュインターバル
 * @param pageSize ページサイズ
 */


export default function (el, common, queryRefreshInterval, pageSize) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    queryRefreshInterval: queryRefreshInterval,
    pageSize: pageSize
  }), el);
}